import { BLOGS } from "../../constants/BlogConstant";
import BlogGrid from "./BlogGrid";

const Blog = () => {
  return (
    <div className="home3-blog-area sec-mar">
      <div className="container">
        <div
          className="row mb-55  wow animate__animated animate__fadeInUp"
          data-wow-delay="200ms"
          data-wow-duration="1500ms">
          <div className="col-lg-12 d-flex justify-content-center">
            <div className="section-title-3 text-center">
              <h2>The Latest Article</h2>
              <p>
                Services are professional offerings provided by businesses to
                meet specific needs or solve problems for their customers.
                Services can range from your budget.
              </p>
            </div>
          </div>
        </div>
        <BlogGrid blogs={BLOGS} limit={3} />
      </div>
    </div>
  );
};

export default Blog;
